import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCashedWiresTransactionReport extends Layout {
    sourceCashedWiresTransactionReport: DataSource;
    textboxFuelInterfaceId: Textbox;
    textboxTransactionDate: Textbox;
}
